import React from 'react';

const styles = {
  Card: {
    top: '116px',
    left: '794px',
    width: '165px',
    height: '28px',
   
    color: '#ffffff',
    fontSize: '14px',
    lineHeight: '16px',
    display: 'flex', // Asettaa elementin flex-containeriksi
    justifyContent: 'center', // Keskittää lapsielementit horisontaalisesti
    alignItems: 'center', // Keskittää lapsielementit vertikaalisesti
  },
};

const defaultProps = {
    text: 'Vko 8: 19.2 - 25.2',
  };

const WeekTextBox = (props) => {
  return (
    <div style={styles.Card}>
       {props.text ?? defaultProps.text}
    </div>
  );
};

export default WeekTextBox;